import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { useAuth } from '../../context/AuthContext';

// Module placement for the user panel — active community members.
// Nav links are sparse: modules the member can actually access are injected
// as those pages are built. For now: dashboard + membership status.
const UserShell = () => {
  const { activeTenant, isModuleEnabled } = useAuth();

  const nav = [
    { to: '/dashboard',  label: 'Dashboard' },
    { to: '/membership', label: 'My Membership' },
    isModuleEnabled('communityNews') && { to: '/community-news', label: 'Community News' },
    isModuleEnabled('communityData') && { to: '/community-data', label: 'Community Data' },
    isModuleEnabled('landValues')    && { to: '/land-values',    label: '🗺️ Land Values' },
    isModuleEnabled('landUnits')     && { to: '/land-units',     label: '🗾 Land Units' },
  ].filter(Boolean);

  return (
    <div className="shell shell--user">
      <Navbar />
      {activeTenant?.branding?.bannerText && (
        <div className="shell-community-banner">
          {activeTenant.branding.bannerText}
        </div>
      )}
      <div className="shell-body">
        <nav className="shell-sidenav" aria-label="Member navigation">
          <span className="shell-sidenav__heading">
            {activeTenant?.branding?.displayName || activeTenant?.name || 'My Community'}
          </span>
          <ul>
            {nav.map(({ to, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    isActive ? 'shell-sidenav__link shell-sidenav__link--active' : 'shell-sidenav__link'
                  }
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <main className="shell-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default UserShell;
